import { render, staticRenderFns } from "./WhatsAppQr.vue?vue&type=template&id=4d5833da"
import script from "./WhatsAppQr.vue?vue&type=script&lang=js"
export * from "./WhatsAppQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports